export default "__VITE_ASSET__f0624f14__"